import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,        // 5 minutes
      cacheTime: 30 * 60 * 1000,       // 30 minutes (deprecated in v5, now gcTime)
      gcTime: 30 * 60 * 1000,          // 30 minutes (new name in v5)
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});

// Cache time configurations by content type
export const CACHE_TIMES = {
  // Published content (changes rarely)
  SERIES_LIST: 15 * 60 * 1000,         // 15 minutes
  SERIES_DETAIL: 10 * 60 * 1000,       // 10 minutes
  LESSON_DETAIL: 0,                    // 0 - TEMP: Force fresh fetch during development
  PAGE_CONTENT: 0,                     // 0 - TEMP: Force fresh fetch during development

  // User progress (changes frequently)
  USER_PROGRESS: 5 * 1000,             // 5 seconds - quick refresh for immediate feedback

  // Draft content (always fresh)
  DRAFT_CONTENT: 0,                    // No cache
};
